import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { DashBoardRfariasComponent } from './dashboard-rfarias.component';
import { DashBoardRfariasRoutingModule } from './dashboard-rfarias-routing.module';


@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    DashBoardRfariasRoutingModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule
  ],
  declarations: [
    DashBoardRfariasComponent
  ]
})
export class DashBoardRfariasModule { }
